import { createFileRoute, redirect } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { PageLayout } from "@/components/layouts/page/layout";

export const Route = createFileRoute("/(private)")({
  component: PageLayout,
  beforeLoad: async ({ location }) => {
    const { data } = await sdk.users.me.$get.send();

    if (!data) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }

    const hasOrganization = Boolean(data.organizationId) && (data.organizations?.length ?? 0) > 0;
    if (!hasOrganization) {
      throw redirect({
        to: "/onboarding",
        search: location.pathname === "/" ? {} : { redirect: location.pathname },
      });
    }

    return { user: data };
  },
});
